import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"



import Button from 'primevue/button';

import { useCopyCalculation } from '../composables/useCopyCalculation';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationCopyButton',
  props: {
    calculationId: {}
  },
  setup(__props: any) {

const props = __props;

const { isLoading, copyCalculation } = useCopyCalculation(() => props.calculationId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: "!p-2",
    size: "small",
    severity: "secondary",
    outlined: "",
    loading: _unref(isLoading),
    title: "Stwórz kopię kalkulacji",
    onClick: _unref(copyCalculation)
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("i", { class: "pi pi-copy" }, null, -1)
    ])),
    _: 1
  }, 8, ["loading", "onClick"]))
}
}

})